import { ref } from 'config/constants'

import {
  FETCH_USER_PROFILE,
  FETCH_USER_ACCOUNT,
} from './types';

const Users = ref.child("users");
const Accounts = ref.child("accounts");

/* USER_PROFILE */
export function updateFbProfile(user, account) {
  return dispatch => user.updateUserInfo(account);
}

export function updateUserProfile(uid, user) {
  return dispatch => Users.child(uid).set(user);
}

export function fetchUserProfile(uid) {
  return dispatch => {
    
    Users.child(uid).on('value', snapshot => {
      var user = snapshot.val();
      dispatch({
        type: FETCH_USER_PROFILE,
        payload: user
      });


    
        Accounts.child(user.info.accountid).on('value', snapshot => {
          dispatch({
            type: FETCH_USER_ACCOUNT,
            payload: snapshot.val()
          });
        });    
    });
  };
}


export function fetchUserAccount(accountid) {
  return dispatch => {
    
    Accounts.child(accountid).on('value', snapshot => {
      dispatch({
        type: FETCH_USER_ACCOUNT,
        payload: snapshot.val()
      });

    });
  };
}




// WEBPACK FOOTER //
// ./src/data/profile/actions.js